import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { css } from 'twin.macro';
import { toast } from 'react-toastify';
import { Button, Form } from 'react-bootstrap';
import { setUser, setloginUser } from '../../../_redux/actions/ActionUser';
import { setToken } from '@/_helpers';
import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';

const GUEST_NAME_KEY = 'conferenceGuestName';

const Component = ({ embedded = false }) => {
    const { meetId: conferenceId } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);

    const getGuestSession = () => {
        try {
            const session = localStorage.getItem('guestSession');
            return session ? JSON.parse(session) : null;
        } catch {
            return null;
        }
    };

    const setGuestSession = (sessionData) => {
        localStorage.setItem('guestSession', JSON.stringify(sessionData));
    };

    const clearGuestSession = () => {
        localStorage.removeItem('guestSession');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim()) {
            toast.error('Please enter your name');
            return;
        }

        setLoading(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}conference/${conferenceId}/guest/join`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name,
                }),
            });

            if (!res.ok) {
                const err = await res.json().catch(() => ({}));
                throw new Error(err.message || 'Failed to join conference');
            }

            const data = await res.json();
            const { user, tokens, } = data;

            // Store guest session information
            setGuestSession({
                conferenceId,
                userId: user.id,
                joinedAt: new Date().toISOString(),
            });

            dispatch(setUser(user));
            dispatch(setloginUser());
            setToken(tokens.access, tokens.refresh);

            if (!embedded) {
                history.push(`/meet/${conferenceId}`);
            }
        } catch (error) {
            console.error(error);
            toast.error(error.message || 'Failed to join conference');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const session = getGuestSession();
        if (session && session.conferenceId !== conferenceId) {
            clearGuestSession();
        }
    }, [conferenceId]);
    useEffect(() => {
        const savedName = localStorage.getItem(GUEST_NAME_KEY);
        if (savedName) {
            setName(savedName);
        }
    }, []);

    return (
        <div
            css={css`
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
                background-color: #f8f9fa;
            `}
        >
            <div
                css={css`
                    background: white;
                    padding: 2rem;
                    border-radius: 8px;
                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                    width: 100%;
                    max-width: 400px;
                `}
            >
                <h2 className="text-center mb-4">Join Conference</h2>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="guestName">
                        <Form.Label>Enter your name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="John Doe"
                            value={name}
                            onChange={(e) => {
                                const value = e.target.value;
                                setName(value);
                                localStorage.setItem(GUEST_NAME_KEY, value);
                            }}
                            disabled={loading}
                        />
                    </Form.Group>
                    <Button variant="primary" type="submit" className="w-100 mt-3" disabled={loading}>
                        {loading ? 'Joining...' : 'Join Meeting'}
                    </Button>
                </Form>
                <Button
                    variant="outline-primary"
                    className="w-100 mt-3"
                    onClick={() => history.push('/login')}
                    disabled={loading}
                >
                    Login
                </Button>
            </div>
        </div>
    );
};

const GuestJoin = (props) => {
    return (
        <ComponentErrorBoundary componentErrorMessage={props?.componentErrorMessage}>
            <Component {...props} />
        </ComponentErrorBoundary>
    );
};

export default GuestJoin;
